import Logo from "./logo";

export default function PopupHeader({
  isPro,
  trialMode,
  remainingTrialDays,
  subscriptionStatusStep,
  notSupported,
  musicProOnly,
  isSlowedEnabled,
  slowedFxActive,
  contentApplying,
  mount,
  billingLoading,
  onUpgradeClick,
  onManageSubscriptionClick,
  onDebugToggle,
  onSlowedToggle,
  hideManagePlan,
}) {
  const hasTrial = trialMode && remainingTrialDays >= 0;
  const step = hasTrial ? subscriptionStatusStep : 0;
  const trialEnded = !isPro && remainingTrialDays < 0;
  const daysText =
    remainingTrialDays > 0
      ? `${remainingTrialDays} ${remainingTrialDays === 1 ? "day" : "days"} left`
      : "Last day";

  return (
    <div className="header">
      <div className="header__content">
        <div className="header__left_button">
          {!isPro && (
            <button
              type="button"
              className={`subscription-status-button subscription-status-button--step-${step} ${trialEnded ? "subscription-status-button--glow" : ""}`}
              onClick={onUpgradeClick}
            >
              <span className="subscription-status-button__label subscription-status-button__label--default">
                Unlock PRO
              </span>
              {hasTrial && (
                <span className="subscription-status-button__label subscription-status-button__label--trial-mode">
                  Trial mode
                </span>
              )}
              {hasTrial && (
                <span className="subscription-status-button__label subscription-status-button__label--trial-days">
                  {daysText}
                </span>
              )}
            </button>
          )}
          {isPro && !hideManagePlan && (
            <button
              type="button"
              className={`subscription-status-button${billingLoading ? " subscription-status-button--loading" : ""}`}
              disabled={billingLoading}
              aria-busy={billingLoading}
              onClick={onManageSubscriptionClick}
            >
              {billingLoading ? (
                <span className="subscription-status-button__loading">
                  <span className="header__spinner" aria-hidden="true" />
                  Loading
                </span>
              ) : (
                <span className="subscription-status-button__label subscription-status-button__label--default">
                  Manage plan
                </span>
              )}
            </button>
          )}
        </div>

        <div
          className={`header__title${slowedFxActive ? " header__title--slowed" : ""}`}
          onDoubleClick={(e) => e.metaKey && onDebugToggle()}
        >
          <Logo isPro={isPro} trialMode={trialMode} />
        </div>

        <div className="header__right_button">
          {contentApplying ? (
            <span className="header__applying" aria-live="polite">
              <span className="header__spinner" aria-hidden="true" />
              Applying
            </span>
          ) : notSupported ? (
            <span className="header__status header__status--muted">
              Unsupported
            </span>
          ) : musicProOnly ? (
            <span className="header__status header__status--muted">
              Pro only
            </span>
          ) : !isSlowedEnabled && mount ? (
            <span className="header__status">Off</span>
          ) : null}
          <input
            type="checkbox"
            className="switcher"
            checked={isSlowedEnabled}
            disabled={notSupported || musicProOnly || contentApplying}
            onChange={() => onSlowedToggle(!isSlowedEnabled)}
          />
        </div>
      </div>

      <div className="header__bar" />
    </div>
  );
}
